/**
 * A collection of utility functions for working with strings.
 */

/**
 * Converts a string to uppercase.
 * 
 * @param {string} text - The string to convert.
 * @returns {string} The string in uppercase.
 */
export const toUppercase = (text) => text.toUpperCase()

/**
 * Converts a string to lowercase.
 * 
 * @param {string} text - The string to convert.
 * @returns {string} The string in lowercase.
 */
export const toLowercase = (text) => text.toLowerCase()